export default __webpack_public_path__ + "static/media/lm_vc_2.dada0b76.jpg";